module.exports = __webpack_public_path__ + "fonts/Inter-300-latin-ext41.ad4eb06.woff2";